import { render, staticRenderFns } from "./platformiklandigital.vue?vue&type=template&id=2a99b1b6"
import script from "./platformiklandigital.vue?vue&type=script&lang=js"
export * from "./platformiklandigital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports